import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";

import CloudDownload from "@material-ui/icons/CloudDownload";

const styles = theme => ({
  para: {
    fontSize: 16
  },
  button: {
    margin: theme.spacing.unit,
    fontSize: 16
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    width: "80%"
  }
});

const Inkscape = props => {
  const { classes } = props;
  return (
    <div>
      <Typography variant="h4">Vector graphics</Typography>
      <Typography className={classes.para} paragraph>
        <Link href={"https://en.wikipedia.org/wiki/Vector_graphics"}>
          Vector graphics
        </Link>{" "}
        are computer graphics images that are defined in terms of 2D points,
        which are connected by lines and curves to form polygons and other
        shapes. It has the advantage of scalability without loss of resolution.
        Modern displays and printers are raster devices; vector formats have to
        be converted to raster format (bitmaps – pixel arrays) before they can
        be rendered (displayed or printed).
      </Typography>

      <Typography variant="h4">Inkscape</Typography>
      <Typography className={classes.para} paragraph>
        <Link href={"https://inkscape.org/"}>Inkscape</Link> is professional
        quality vector graphics software. Inkscape uses the W3C open standard
        SVG (Scalable Vector Graphics) as its native format, and is free and
        open-source software.
      </Typography>
      <Typography className={classes.para} paragraph>
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./inkscape/drawing.svg"
            alt="Rhino"
          />
        </div>{" "}
        <Button
          variant="contained"
          size="small"
          color="primary"
          className={classes.button}
          target="_blank"
          href={"./inkscape/drawing.svg"}
        >
          <CloudDownload className={classes.leftIcon} />
          Download file
        </Button>
        <br />I attempted to learn Inkscape by learning how to produce
        info-graphics in inkscape. The animation shows how I created a basic 3D
        pie chart in 2.5D vector image.
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./inkscape/inkscape1.gif"
            alt="Rhino"
          />
        </div>{" "}
      </Typography>
      <Typography className={classes.para} paragraph>
        I started by creating a circle.
        <br /> I needed to cut it in three equal pieces. So, I created a thin
        rectangular line and aligned it. Next, I made duplicates of that
        rectangle and rotated around the image of center. The rotation is made
        possible by moving the center of rectangle to match with center of
        circle.
        <br /> Then, I used 'difference' to cut the circle. Next, I created a
        background rectangle with smooth edges. I scaled the image in required
        direction to create a 3D perception. I used 'break-apart' in 'path'
        tools to separate the pieces of circle into objects.
        <br /> I used 'Bezier' tool and 'Union' to complete 3D object.
        Then,'edit path by nodes' tool to make changes in the lengths of 3D
        perception.
      </Typography>
    </div>
  );
};

export default withStyles(styles)(Inkscape);
